// extracted by mini-css-extract-plugin
export default {"logout":"LogoutBtn_logout__gtZME"};